import {Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild, Input} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ReferenceArea } from '../../models/reference-area';

@Component({
  selector: 'app-reference-area-edit',
  template: require('./reference-area-edit.component.html'),
  styles: [require('./reference-area-edit.component.sass')]
})
export class ReferenceAreaEditComponent implements OnInit {

  @ViewChild('referenceAreaEditModal') referenceAreaEditModal: ElementRef;
  @Input() usedReferenceIds: number[] | null;
  @Output() save = new EventEmitter<ReferenceArea>();
  @Output() delete = new EventEmitter<ReferenceArea>();


  projectId: number;
  referenceArea: ReferenceArea | undefined;
  referenceAreaEditModalReference: NgbModalRef;
  editDisabled: boolean;

  constructor(
    @Inject('ProjectService') private projectService: any,
    private modalService: NgbModal
  ) {
  }

  ngOnInit(): void {
    this.projectId = this.projectService.getSelectedProjectId();
  }

  async showModal(referenceArea?: ReferenceArea, editDisabled?: boolean) {
    this.editDisabled = editDisabled || false;
    if (referenceArea) {
      this.referenceArea = {...referenceArea};
    } else {
      this.referenceArea = undefined;
    }
    this.referenceAreaEditModalReference = await this.modalService.open(this.referenceAreaEditModal, {
      size: 'lg'
    })
  }

  onSave = (referenceArea: ReferenceArea) => {
    this.save.emit(referenceArea)
    this.referenceAreaEditModalReference.close();
  }
  onDelete = (referenceArea: ReferenceArea) => {
    this.delete.emit(referenceArea)
    this.referenceAreaEditModalReference.close();
  }

  onCancel = () => {
    this.referenceAreaEditModalReference.close();
  }
}
